<!-- ws:rollout: same shell / rows as the row-detail panels. The token is fetched after the panel
     opens, so this shows a spinner while loading, an inline error on failure, then the token with
     its own copy button; the footer spaces Cancel and Copy apart. -->
<payarc-dialog-shell title="API token" (closed)="closeAction()">
  <payarc-detail-card [flat]="true" [rows]="detailRows"></payarc-detail-card>

  <div class="at-token">
    <div class="at-token__head">
      <span class="at-token__label">API / Bearer token</span>
      <button type="button" class="at-token__copy" *ngIf="token" [class.is-copied]="copied" (click)="copy(token)"
              [attr.aria-label]="copied ? 'Copied' : 'Copy token'">
        <svg *ngIf="!copied" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h8"/>
        </svg>
        <svg *ngIf="copied" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">
          <path d="M5 13l4 4L19 7"/>
        </svg>
        {{ copied ? 'Copied' : 'Copy' }}
      </button>
    </div>

    <!-- loading: waiting for the reveal response -->
    <div class="at-token__box at-token__box--state" *ngIf="loading">
      <span class="at-spinner" aria-hidden="true"></span>
      <span class="at-state-text">Revealing token…</span>
    </div>

    <!-- error: the reveal call failed -->
    <payarc-inline-alert variant="bad" *ngIf="!loading && error">{{ error }}</payarc-inline-alert>

    <!-- loaded -->
    <div class="at-token__box" *ngIf="!loading && !error && token"><code>{{ token }}</code></div>

    <!-- copy failed: the token stays visible above, this only tells the user to copy it by hand -->
    <payarc-inline-alert variant="bad" *ngIf="copyError" class="at-copy-error">{{ copyError }}</payarc-inline-alert>
  </div>

  <div footer class="at-foot">
    <button type="button" payarcButton="ghost" (click)="closeAction()">Cancel</button>
    <button type="button" payarcButton="primary" [disabled]="!token || loading" (click)="copy(token)">
      {{ copied ? 'Copied' : 'Copy token' }}
    </button>
  </div>
</payarc-dialog-shell>
